import React from 'react';
import { Button, Box, Typography } from '@mui/material';

const StartPage = ({ onStart }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="50vh"
        >
            <Typography variant="h5" gutterBottom>
                Willkommen bei PRIMA VO-Check
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={onStart}
            >
                Neue Verordnung erfassen
            </Button>
        </Box>
    );
};

export default StartPage;
